import { useContext, useState } from "react";
import AppContext from "../Context/AppContext";
import { LOGOUTICON } from "../Utils/icons";
import CustomButton from "./Base/CustomButton";
import Modal from "./Modal";
export default function SessionOut() {
  const { isSessionExpeired, logoutHandler } = useContext(AppContext);
  const clickHandler = () => {
    logoutHandler();
  };
  return (
    <div className="session-model">
      <Modal
        isOpen={isSessionExpeired}
        title={"Session Experied"}
        cstmClassName={"session-custom-model"}
      >
        <div className="session-wrap">
          <div>Session Experied Kindly Login</div>
          <div>
            <CustomButton buttonHandler={clickHandler} label={<LOGOUTICON />} />
          </div>
        </div>
      </Modal>
    </div>
  );
}
